import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';



export default function IECCodes() {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 200 }} aria-label="spanning table">
        <TableHead  style={{backgroundColor:'gray'}}>
          
          <TableRow>
            <TableCell>R1</TableCell>
            <TableCell>R2</TableCell>
            <TableCell>R3</TableCell>
            <TableCell>R4</TableCell>
            <TableCell>R5</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>          
            <TableRow key="1">
              <TableCell>CH4/H2</TableCell>
              <TableCell>C2H2/C2H4</TableCell>
              <TableCell>C2H2/CH4</TableCell>
              <TableCell>C2H6/C2H2</TableCell>
              <TableCell>C2H4/C2H6</TableCell>
            </TableRow>
            <TableRow key="2">
              <TableCell>0.25</TableCell>
              <TableCell>0.32</TableCell>
              <TableCell>2.33</TableCell>
              <TableCell>0.43</TableCell>
              <TableCell>7.33</TableCell>
            </TableRow>

          <TableRow style={{backgroundColor:'gray'}}>
            <TableCell colSpan={4} align="right"><b>Dornenburg</b></TableCell>
            <TableCell align="left"><b>No Diagnosis</b></TableCell>
          </TableRow>
          <TableRow style={{backgroundColor:'gray'}}>
            <TableCell colSpan={4} align="right"><b>Rogers Ratio</b></TableCell>
            <TableCell align="left"><b>High Energy Discharge Arcing</b></TableCell>            
          </TableRow>
          
        </TableBody>
      </Table>
    </TableContainer>
  );
}